import React from 'react';

const groupStyle = { gap: 0, border: '1px solid var(--border-color)', background: 'transparent', padding: 0, borderRadius: '12px' };

const StripeAmountSelector = ({
  usdAmount,
  kaxAmount,
  onUsdChange,
  onKaxChange,
  presetAmounts,
  onPresetClick,
  minAmount = 10,
  quote,
  quoteLoading,
  quoteError,
}) => {
  const fee = quote ? parseFloat(usdAmount || 0) * quote.feePercent + quote.feeFixed : 0;

  return (
    <>
      <div className="d-flex justify-content-center gap-2 mb-4">
        {presetAmounts.map((preset) => (
          <button
            key={preset}
            type="button"
            className={`btn px-4 py-2 ${usdAmount === preset ? 'btn-custom-theme-active text-white' : 'btn-custom-theme-outline'}`}
            onClick={() => onPresetClick(preset)}
            style={{ borderRadius: '12px', fontWeight: '600' }}
          >
            ${preset}
          </button>
        ))}
      </div>

      <div className="mb-2">
        <label htmlFor="stripe-usd-amount" className="form-label text-sm font-semibold text-muted">You Pay</label>
        <div className="input-group" style={groupStyle}>
          <span
            className="input-group-text bg-transparent border-end-0 font-semibold text-muted"
            style={{ borderRadius: '12px 0 0 12px', border: 'none' }}
          >
            $
          </span>
          <input
            id="stripe-usd-amount"
            type="number"
            min={minAmount}
            className="form-control border-start-0 font-semibold custom-amount-input"
            placeholder="Enter amount"
            value={usdAmount}
            onChange={(e) => onUsdChange(e.target.value)}
            style={{ borderRadius: '0 12px 12px 0', border: 'none' }}
          />
        </div>
        {parseFloat(usdAmount) < minAmount && (
          <div className="text-danger text-xs mt-1">Minimum amount is ${minAmount} USD</div>
        )}
      </div>

      <div className="text-center text-muted my-1" style={{ fontSize: '1.1rem', lineHeight: 1 }}>&darr;</div>

      <div className="mb-4">
        <label htmlFor="stripe-kax-amount" className="form-label text-sm font-semibold text-muted">You Receive</label>
        <div className="input-group" style={groupStyle}>
          <input
            id="stripe-kax-amount"
            type="number"
            min="0"
            className="form-control border-end-0 font-semibold custom-amount-input"
            placeholder="0.00"
            value={kaxAmount}
            onChange={(e) => onKaxChange(e.target.value)}
            style={{ borderRadius: '12px 0 0 12px', border: 'none' }}
          />
          <span
            className="input-group-text bg-transparent border-start-0 font-semibold text-muted"
            style={{ borderRadius: '0 12px 12px 0', border: 'none' }}
          >
            KAX
          </span>
        </div>
      </div>

      <div className="card bg-light dark:bg-gray-800/10 p-3 mb-4 border-0" style={{ borderRadius: '12px' }}>
        {quoteLoading ? (
          <div className="text-xs text-muted text-center">Loading live price...</div>
        ) : quoteError ? (
          <div className="text-xs text-danger text-center">{quoteError}</div>
        ) : (
          <>
            <div className="d-flex align-items-center justify-content-between text-xs text-muted mb-1">
              <span>KAX Price:</span>
              <span className="font-semibold text-dark dark:text-light">${quote?.kaxPrice ? quote.kaxPrice.toFixed(4) : '--'}</span>
            </div>
            <div className="d-flex align-items-center justify-content-between text-xs text-muted">
              <span>Stripe Fee (2.9% + $0.30):</span>
              <span className="font-semibold text-dark dark:text-light">${fee.toFixed(2)}</span>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default StripeAmountSelector;
